import React from 'react';
import { Badge, Card } from 'react-bootstrap';

export default function RiggingOperationCard({
  operation,
  selected,
  onSelect,
  disabled,
  unavailableReason,
}) {
  const availability = operation.availability();
  const isDisabled = disabled || !availability.available;
  const reason = unavailableReason || availability.reason;

  return (
    <Card
      as="button"
      type="button"
      className={`text-start mb-2 w-100 ${selected ? 'border-primary' : ''}`}
      style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.65 : 1 }}
      onClick={() => {
        if (!isDisabled) onSelect(operation.id);
      }}
      aria-pressed={selected}
      aria-disabled={isDisabled}
      data-testid={`rigging-op-${operation.id}`}
      disabled={isDisabled}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start gap-2">
          <div>
            <Card.Title className="h6 mb-1">{operation.label}</Card.Title>
            <Card.Text className="small text-muted mb-2">{operation.description}</Card.Text>
            <div className="small">
              <Badge bg="light" text="dark" className="me-1">
                {operation.resource.toUpperCase()}
              </Badge>
              {isDisabled ? (
                <Badge bg="secondary">Unavailable</Badge>
              ) : (
                <Badge bg="success">Available to configure</Badge>
              )}
            </div>
            {isDisabled && reason ? (
              <div className="small text-muted mt-2">{reason}</div>
            ) : null}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
